import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center gap-1 w-full mb-5" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnClickAffiliateLink && _ctx.btnClickAffiliateLink(...args))),
      type: "button",
      class: _normalizeClass([{'opacity-100': _ctx.session.get('navbar_sub') === 'affiliate:detail'}, "flex justify-center items-center w-full cursor-pointer opacity-95"])
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("img", {
        src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn001.webp",
        alt: "",
        class: ""
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.btnClickAffiliateHistory && _ctx.btnClickAffiliateHistory(...args))),
      type: "button",
      class: _normalizeClass([{'opacity-100': _ctx.session.get('navbar_sub') === 'affiliate:transaction'}, "flex justify-center items-center w-full cursor-pointer opacity-95"])
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("img", {
        src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn002.webp",
        alt: "",
        class: ""
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.btnClickAffiliateReport && _ctx.btnClickAffiliateReport(...args))),
      type: "button",
      class: _normalizeClass([{'opacity-100': _ctx.session.get('navbar_sub') === 'affiliate:report'}, "flex justify-center items-center w-full cursor-pointer opacity-95"])
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("img", {
        src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn003.webp",
        alt: "",
        class: ""
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.btnClickAffiliateDownline && _ctx.btnClickAffiliateDownline(...args))),
      type: "button",
      class: _normalizeClass([{'opacity-100': _ctx.session.get('navbar_sub') === 'affiliate:downline'}, "flex justify-center items-center w-full cursor-pointer opacity-95"])
    }, _cache[7] || (_cache[7] = [
      _createElementVNode("img", {
        src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn004.webp",
        alt: "",
        class: ""
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */)
  ]))
}